<template>
  <div class="page-wrapper">
    <div class="viewpage-caption-container clearFix">
      <div class="title">Purchase Reports</div>
    </div>
    <el-tabs v-model="activeTabName" @tab-click="handleClick" type="border-card">
      <el-tab-pane name="first">
        <span slot="label">
          <i class="el-icon-document"></i> Purchase Orders or Bills Detail (2 sublist)
        </span>
        <el-form ref="form" label-width="120px">
          <ReportBasicSettingPur />
          <ReportProducts :showProductDesignate="false"/>
          <ReportSupplier />
          <div class="submit">
            <el-button type="primary" @click="handleSubmit" size="mini">Submit</el-button>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane name="second">
        <span slot="label">
          <i class="el-icon-notebook-2"></i> Purchase Orders or Bills Summary (2 sublist)
        </span>
        <el-form ref="form" label-width="120px">
          <ReportBasicSettingPur />
          <ReportSupplier />
          <ReportProducts :showProductDesignate="false"/>
          <div class="submit">
            <el-button type="primary" @click="handleSubmit" size="mini">Submit</el-button>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ReportBasicSettingPur from '../components/ReportBasicSettingPur'
import ReportProducts from '../components/ReportProducts'
import ReportSupplier from '../components/ReportSupplier'
import { mapActions } from 'vuex'

export default {
  name: 'reportPurchase',
  components: {
    ReportBasicSettingPur,
    ReportProducts,
    ReportSupplier
  },
  created () {
    this.initPurDetails()
  },
  data () {
    return {
      activeTabName: 'first',
      tabsVifFlag: 1
    }
  },
  methods: {
    ...mapActions({
      initPurDetails: 'report/initPurDetails',
      initPurSummary: 'report/initPurSummary',
      queryPurchaseDetails: 'report/purchaseDetails'
    }),
    handleClick (tab, event) {
      if (tab.name === 'first') {
        this.tabsVifFlag = 1
        this.initPurDetails()
      } else if (tab.name === 'second') {
        this.tabsVifFlag = 2
        this.initPurSummary()
      }
    },
    async handleSubmit () {
      // todo
      await this.queryPurchaseDetails()
      this.$message({
        message: 'Preparing for the report, please check it later',
        type: 'success'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  text-align: left;
  max-width: 1660px;
}
.viewpage-caption-container {
  height: 32px;
  line-height: 32px;
  margin-bottom: 12px;
}
.title {
  float: left;
  text-align: left;
  font-size: 18px;
  color: #939393;
  text-indent: 8px;
  font-weight: bold;
}
.btn,
.btn-secondary {
  height: 32px;
  margin-left: 12px;
  padding: 0 16px;
  line-height: 32px;
}
.clearFix::after {
  content: '';
  display: block;
  height: 0;
  clear: both;
}
.submit {
  margin-top: 20px;
}
</style>
